import { EMPTY_GUID } from "@utils/helpers";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ActionConfirmModal } from "shared/modals";
import { GenericButton, IconDispatcher, Label } from "shared/ui-basics";
import { useModal } from "use-modal-hook";
import { upsertConnector } from "../reducer/ConnectorAction";
import * as Style from "./Styles";

const IntegrationCard = ({ integration, integrations }) => {
	const { t } = useTranslation();

	const connectors = useSelector((state) => state.settings.connector)?.filter((connector) => connector.source === integration?.source) || [];
	const [actionConfirmModal] = useModal(ActionConfirmModal);

	const updateConnector = (connector) => {
		upsertConnector({ connector: { ...connector, enableConnection: false } });
	};
	const redirect = (connector) => {
		integration?.onClick(connector?.id);
	};
	const onClick = (connector) => {
		if (!connector?.enableConnection) {
			redirect(connector);
		} else {
			actionConfirmModal({
				bodyContent: t("CONNECTOR_DISABLE") + `"${connector?.name}"?`,
				Action: () => updateConnector(connector),
				actionBtnText: "DISABLE",
				title: "Disable Connector",
			});
		}
	};
	return (
		<Style.WrapperBox className="mb-4">
			<Style.WrapperDiv>
				<Col xs={6}>
					<div className="d-flex align-items-center mb-4">
						<Style.ImgWrapper className="me-3" src={integrations[integration?.icon]?.default} />
						<Label size={20}>{t(integration?.name)}</Label>
					</div>
					<div>{t(integration?.description)}</div>
				</Col>
				<Style.WrapperRight xs={2}>
					<GenericButton className={integration?.classButton} variant={integration?.variant} disabled={integration?.disable} onClick={() => integration?.onClick(EMPTY_GUID)}>
						{t(integration?.buttonName)}
					</GenericButton>
				</Style.WrapperRight>
			</Style.WrapperDiv>
			{connectors?.length > 0 &&
				connectors?.map((connector, index) => (
					<Style.WrapperConnector className="mx-3" key={index}>
						<div className="d-flex justify-content-between">
							<Style.WrapperColHerf xs={6}>
								<Style.WrapperHerf
									size={14}
									onClick={() => {
										redirect(connector);
									}}>
									{connector?.name}
								</Style.WrapperHerf>
							</Style.WrapperColHerf>
							<Style.WrapperRight xs={2}>
								<GenericButton
									variant={connector?.enableConnection ? "dark-outline" : "dark"}
									size="s"
									onClick={() => {
										onClick(connector);
									}}>
									{connector?.enableConnection ? t("DISABLE") : t("ENABLE")}
								</GenericButton>
							</Style.WrapperRight>
						</div>
						{connector?.errorMsg !== "" && (
							<Style.WrapperRowError>
								<div>{IconDispatcher("triangle-exclamation", "", { style: "solid", color: "#D50000" })}</div>
								<Label size={12} color="#D50000">
									{t("ERROR")} : {connector?.errorMsg}
								</Label>
							</Style.WrapperRowError>
						)}
					</Style.WrapperConnector>
				))}
		</Style.WrapperBox>
	);
};
export default IntegrationCard;
